import { useLocation, useNavigate } from "react-router-dom";
import "./gbn.scss";
import { useState, useRef, useEffect, MouseEvent } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setMessage } from "store/commonSlice";

const GBN = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const memType = pathname.includes("admin")
    ? "admin"
    : pathname.includes("manager")
    ? "manager"
    : localStorage.getItem("memType");

  const [isOpen, setIsOpen] = useState<string>(
    pathname.replace(`/${memType}/`, "")
  );

  const ulRef = useRef<HTMLUListElement>(null);

  const handleOpen = (type: string) => {
    const sltLodNo = localStorage.getItem("sltLodNo");

    if (memType === "manager" && !sltLodNo) {
      dispatch(
        setMessage({
          message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
          isConfirm: true,
          handleClick() {
            dispatch(setMessage({ message: null }));
          },
        })
      );
      return;
    }

    setIsOpen(type);
    navigate(`/${memType}/${type}`);

    // if (ulRef.current) {
    //   const height = ulRef.current.children.length * 48 + "px";
    //   ulRef.current.style.height = height;
    // }
  };

  const handleClick = () => {
    const sltLodNo = localStorage.getItem("sltLodNo");
    if (memType === "manager" && !sltLodNo) {
      dispatch(
        setMessage({
          message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
          isConfirm: true,
          handleClick() {
            dispatch(setMessage({ message: null }));
          },
        })
      );
      return;
    }
  };

  useEffect(() => {
    setIsOpen(pathname);
  }, [pathname]);

  return (
    <section className="gbn-wrap">
      <ul className="menu-wrap">
        <li>
          <button
            className={
              pathname === `/${memType}` || pathname === "/"
                ? "no-arrow rotate"
                : "no-arrow"
            }
            onClick={() => {
              setIsOpen("home");
              navigate(`/${memType}`);
            }}
          >
            <span>{"홈"}</span>
          </button>
        </li>
        {memType === "admin" && (
          <div>
            <button
              onClick={() => {
                handleOpen("mem");
              }}
              className={
                isOpen === "mem" || pathname.includes("mem") ? "rotate" : ""
              }
            >
              회원
            </button>
            <ul className={isOpen === "mem" ? "sub-menu" : "hidden"}>
              <li>
                <NavLink
                  to={`${memType}/mem`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                  onClick={(e) => {
                    if (e.currentTarget.className === "active") {
                      e.preventDefault();
                    }
                  }}
                >
                  회원
                </NavLink>
              </li>
            </ul>
          </div>
        )}
        {memType === "admin" && (
          <li>
            <button
              onClick={() => handleOpen("lod/grp")}
              className={pathname.includes("lod") ? "rotate" : ""}
            >
              숙소관리
            </button>
            <ul
              className={isOpen.includes("lod") ? "sub-menu" : "hidden"}
              ref={ulRef}
            >
              <li className={pathname === "/lod/grp" ? "on" : ""}>
                <NavLink
                  to={`${memType}/lod/grp`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  숙소그룹
                </NavLink>
              </li>
              <li className={pathname === "/lod/lod" ? "on" : ""}>
                <NavLink
                  to={`${memType}/lod/lod`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  숙소
                </NavLink>
              </li>
              <li className={pathname === "/lod/dflt" ? "on" : ""}>
                <NavLink
                  to={`${memType}/lod/dflt`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  숙소기본정보
                </NavLink>
              </li>
              <li className={pathname === "/lod/prd" ? "on" : ""}>
                <NavLink
                  to={`${memType}/lod/prd`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  숙소제공정보
                </NavLink>
              </li>
              <li className={pathname === "/lod/rfd" ? "on" : ""}>
                <NavLink
                  to={`${memType}/lod/rfd`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  숙소환불수수료
                </NavLink>
              </li>
              <li className={pathname === "/lod/chl" ? "on" : ""}>
                <NavLink
                  to={`${memType}/lod/chl`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  숙소채널
                </NavLink>
              </li>
              <li className={pathname === "/lod/" ? "on" : ""}>
                <NavLink
                  to={`${memType}/room/room/create`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  숙소요청
                </NavLink>
              </li>
            </ul>
          </li>
        )}
        <div>
          <button
            onClick={() => handleOpen("rmManage/rm")}
            className={pathname.includes("rmManage") ? "rotate" : ""}
          >
            객실관리
          </button>
          <ul
            // className={isOpen.includes("rmManage") ? "sub-menu" : "hidden"}
            className={"sub-menu"}
            ref={ulRef}
          >
            <li>
              <NavLink
                to={`${memType}/rmManage/rm`}
                className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "active" : ""
                }
                onClick={(e) => {
                  if (e.currentTarget.className === "active") {
                    e.preventDefault();
                  }
                  const sltLodNo = localStorage.getItem("sltLodNo");

                  if (memType === "manager" && !sltLodNo) {
                    e.preventDefault();
                    dispatch(
                      setMessage({
                        message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
                        isConfirm: true,
                        handleClick() {
                          dispatch(setMessage({ message: null }));
                        },
                      })
                    );
                    return;
                  }
                }}
              >
                객실
              </NavLink>
            </li>

            <li className={pathname.includes("/rmManage/rmOp") ? "on" : ""}>
              <NavLink
                to={`${memType}/rmManage/rmOp`}
                className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "active" : ""
                }
                onClick={(e) => {
                  if (e.currentTarget.className === "active") {
                    e.preventDefault();
                  }
                  const sltLodNo = localStorage.getItem("sltLodNo");

                  if (memType === "manager" && !sltLodNo) {
                    e.preventDefault();
                    dispatch(
                      setMessage({
                        message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
                        isConfirm: true,
                        handleClick() {
                          dispatch(setMessage({ message: null }));
                        },
                      })
                    );
                    return;
                  }
                }}
              >
                객실옵션
              </NavLink>
            </li>
            {/* <li>
              <Link to="/room/special ">객실특가</Link>
            </li> */}
            <li>
              <NavLink
                to={`${memType}/rmManage/rmPd`}
                className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "active" : ""
                }
                onClick={(e) => {
                  if (e.currentTarget.className === "active") {
                    e.preventDefault();
                  }
                  const sltLodNo = localStorage.getItem("sltLodNo");

                  if (memType === "manager" && !sltLodNo) {
                    e.preventDefault();
                    dispatch(
                      setMessage({
                        message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
                        isConfirm: true,
                        handleClick() {
                          dispatch(setMessage({ message: null }));
                        },
                      })
                    );
                    return;
                  }
                }}
              >
                객실상품
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`${memType}/rmManage/rmHst`}
                className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "active" : ""
                }
                onClick={(e) => {
                  if (e.currentTarget.className === "active") {
                    e.preventDefault();
                  }

                  const sltLodNo = localStorage.getItem("sltLodNo");

                  if (memType === "manager" && !sltLodNo) {
                    e.preventDefault();
                    dispatch(
                      setMessage({
                        message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
                        isConfirm: true,
                        handleClick() {
                          dispatch(setMessage({ message: null }));
                        },
                      })
                    );
                    return;
                  }
                }}
              >
                객실상품이력
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`${memType}/rmManage/current`}
                className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "active" : ""
                }
                onClick={(e) => {
                  if (e.currentTarget.className === "active") {
                    e.preventDefault();
                  }

                  const sltLodNo = localStorage.getItem("sltLodNo");

                  if (memType === "manager" && !sltLodNo) {
                    e.preventDefault();
                    dispatch(
                      setMessage({
                        message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
                        isConfirm: true,
                        handleClick() {
                          dispatch(setMessage({ message: null }));
                        },
                      })
                    );
                    return;
                  }
                }}
              >
                객실현황
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`${memType}/rmManage/resv`}
                className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "active" : ""
                }
                onClick={(e) => {
                  if (e.currentTarget.className === "active") {
                    e.preventDefault();
                  }

                  const sltLodNo = localStorage.getItem("sltLodNo");

                  if (memType === "manager" && !sltLodNo) {
                    e.preventDefault();
                    dispatch(
                      setMessage({
                        message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
                        isConfirm: true,
                        handleClick() {
                          dispatch(setMessage({ message: null }));
                        },
                      })
                    );
                    return;
                  }
                }}
              >
                객실예약
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`${memType}/rmManage/cancel`}
                className={({ isActive, isPending }) =>
                  isPending ? "pending" : isActive ? "active" : ""
                }
                onClick={(e) => {
                  if (e.currentTarget.className === "active") {
                    e.preventDefault();
                  }

                  const sltLodNo = localStorage.getItem("sltLodNo");

                  if (memType === "manager" && !sltLodNo) {
                    e.preventDefault();
                    dispatch(
                      setMessage({
                        message: "[메뉴-홈]에서 숙소를 먼저 선택해 주세요.",
                        isConfirm: true,
                        handleClick() {
                          dispatch(setMessage({ message: null }));
                        },
                      })
                    );
                    return;
                  }
                }}
              >
                객실예약취소
              </NavLink>
            </li>
          </ul>
        </div>
        {memType === "admin" && (
          <>
            <div>
              <button
                onClick={() => handleOpen("promManage/prm")}
                className={pathname.includes("promManage/") ? "rotate" : ""}
              >
                프로모션관리
              </button>
              <ul
                className={
                  isOpen.includes("promManage") ? "sub-menu" : "hidden"
                }
                ref={ulRef}
              >
                <li>
                  <NavLink
                    to={`admin/promManage/prm`}
                    className={({ isActive, isPending }) =>
                      isPending ? "pending" : isActive ? "active" : ""
                    }
                  >
                    프로모션
                  </NavLink>
                </li>
              </ul>
            </div>
            <div>
              <button
                onClick={() => handleOpen("clcltManage/clclt")}
                className={pathname.includes("clcltManage") ? "rotate" : ""}
              >
                정산관리
              </button>
              <ul
                className={
                  isOpen.includes("clcltManage") ? "sub-menu" : "hidden"
                }
                ref={ulRef}
              >
                <li>
                  <NavLink
                    to={`admin/clcltManage/clclt`}
                    className={({ isActive, isPending }) =>
                      isPending ? "pending" : isActive ? "active" : ""
                    }
                  >
                    프로모션 참여
                  </NavLink>
                </li>
              </ul>
            </div>
          </>
        )}
        {memType === "admin" && (
          <div>
            <button
              onClick={() => {
                handleOpen("trmsManage/trm");
              }}
              className={
                isOpen === "trmsManage" || pathname.includes("trmsManage")
                  ? "rotate"
                  : ""
              }
            >
              약관관리
            </button>
            <ul
              className={isOpen.includes("trmsManage") ? "sub-menu" : "hidden"}
              ref={ulRef}
            >
              <li>
                <NavLink
                  to={`admin/trmsManage/trm`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  약관
                </NavLink>
              </li>
              {/* <li>
                <NavLink
                  to={`admin/trmsManage/trm/create`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  약관등록
                </NavLink>
              </li> */}
              {/* <li>
                <NavLink
                  to={`${memType}/term/create`}
                  className={({ isActive, isPending }) =>
                    isPending ? "pending" : isActive ? "active" : ""
                  }
                >
                  약관수정
                </NavLink>
              </li> */}
            </ul>
          </div>
        )}

        {/* <li>
          <button
            onClick={() => handleOpen("board")}
            className={
              isOpen === "board" && pathname.includes("board") ? "rotate" : ""
            }
          >
            게시판 알림관리
          </button>
          <ul
            className={`sub-menu ${
              isOpen === "board" || pathname.includes("board")
                ? "h-[15rem] "
                : "h-0"
            }`}
          >
            <li>
              <Link to="/board/alarm">공지사항</Link>
            </li>
            <li>
              <Link to="/board/fqa">FQA</Link>
            </li>
            <li>
              <Link to="/board/mail">이메일</Link>
            </li>
            <li>
              <Link to="/board/fax">팩스</Link>
            </li>
            <li>
              <Link to="/board/push">푸시</Link>
            </li>
          </ul>
        </li> */}
        {/* <li>
          <button
            onClick={() => handleOpen("setting")}
            className={
              isOpen === "setting" && pathname.includes("setting")
                ? "rotate"
                : ""
            }
          >
            설정
          </button>
          <ul
            className={`sub-menu ${
              isOpen === "setting" || pathname.includes("setting")
                ? "h-[3rem]"
                : "h-0"
            }`}
          >
            <li className={pathname === "/setting" ? "on" : ""}>
              <Link to="/setting">언어</Link>
            </li>
          </ul>
        </li> */}
      </ul>
    </section>
  );
};

export default GBN;
